/**
 * HelpBody — renders markdown-lite help body text (WO-H1).
 * Supports blank-line paragraphs and `- ` bullet lines. No HTML, no external markdown dep.
 * Uses theme tokens only.
 */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '../ui';
import { theme } from '../../theme';

export function HelpBody({ body }: { body: string }) {
  const blocks = body.split('\n').map((l) => l.trimEnd());
  return (
    <View style={styles.wrap}>
      {blocks.map((line, i) => {
        if (line.trim() === '') return <View key={i} style={styles.gap} />;
        if (line.startsWith('- ')) {
          return (
            <View key={i} style={styles.bulletRow}>
              <Text variant="body" color="secondary" style={styles.bulletDot}>
                {'•'}
              </Text>
              <Text variant="body" color="secondary" style={styles.flex}>
                {line.slice(2)}
              </Text>
            </View>
          );
        }
        return (
          <Text key={i} variant="body" color="secondary">
            {line}
          </Text>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: theme.spacing.xs },
  gap: { height: theme.spacing.sm },
  flex: { flex: 1 },
  bulletRow: { flexDirection: 'row', gap: theme.spacing.sm, paddingRight: theme.spacing.sm },
  bulletDot: { width: theme.spacing.md, textAlign: 'center' },
});
